/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {pick} from 'lodash'
import {homeMock, betMock, taskMock, storeMock} from './mock'

export const getHomepage = createAsyncThunk(
  'WordCupCarnival/getHomepage',
  async (p: any, store: any) => {
    // return {...homeMock, ...p}
    const resp = await http.post(
      '/live/activity/world_cup_2026_homepage',
      {...p},
      {
        store: window.store,
      }
    )

    return resp?.data?.data
  }
)

export const world_cup_2026_task = createAsyncThunk(
  'WordCupCarnival/world_cup_2026_task',
  async (p: any, store: any) => {
    // return taskMock
    const resp = await http.post(
      '/live/activity/world_cup_2026_task',
      {...p},
      {
        store: window.store,
      }
    )

    return resp?.data?.data
  }
)

export const world_cup_2026_result_reducer = createAsyncThunk(
  'WordCupCarnival/world_cup_2026_result',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/world_cup_2026_result',
      {...p},
      {
        store: window.store,
      }
    )

    return resp?.data?.data
  }
)

export const world_cup_2026_bet = createAsyncThunk(
  'WordCupCarnival/world_cup_2026_bet',
  async (p: any, store: any) => {
    // return {
    //   ...betMock,
    //   target_list: betMock.target_list.map((item) => {
    //     if (item.target_id === p.target_id) {
    //       return {...item, bet_amounts: item.bet_amounts + p.bet_coins}
    //     }
    //     return item
    //   }),
    // }
    const resp = await http.post(
      '/live/activity/world_cup_2026_bet',
      {...p},
      {
        store: window.store,
        xcErrorToast: true,
      }
    )

    return resp?.data?.data
  }
)

export const world_cup_2026_store = createAsyncThunk(
  'WordCupCarnival/world_cup_2026_store',
  async (p: any, store: any) => {
    // return storeMock
    const resp = await http.post(
      '/live/activity/world_cup_2026_store',
      {...p},
      {
        store: window.store,
        xcErrorToast: true,
      }
    )

    return resp?.data?.data
  }
)

export const getActivityInfo = createAsyncThunk(
  'WordCupCarnival/getActivityInfo',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/commonactivity/get_activity_info',
      {...p},
      {
        store: window.store,
      }
    )

    return resp?.data?.data
  }
)

const initialState = {
  homepage: null,
  tasks: null,
  activityInfo: null,
  store: null,
  cur_result: null,
}

export const WordCupCarnivalSlice = createSlice({
  name: 'WordCupCarnival',
  initialState,
  reducers: {
    updateBetInfo: (state, action) => {
      const target_list = state?.homepage?.target_list
      if (!target_list?.length) return

      const {targets} = action.payload || {}
      if (!targets?.length) return

      for (const item of target_list) {
        const newItem = targets.find((f) => f.target_id === item.target_id)
        item.hot_topn = newItem?.hot_topn ?? 0
        item.total_bet = newItem?.total_bet ?? 0
      }
    },
    updateMessageInfo: (state, action) => {
      const {status} = action.payload
      Object.assign(state.homepage, {
        ...action.payload,
        round_status: status,
      })
    },
    clearCurResult: (state, action) => {
      state.cur_result = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.homepage = data
    })
    builder.addCase(
      world_cup_2026_result_reducer.fulfilled,
      (state, action) => {
        const data = action.payload || {}
        state.cur_result = data
      }
    )
    builder.addCase(world_cup_2026_task.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.tasks = data
    })
    builder.addCase(world_cup_2026_store.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.store = data
    })
    builder.addCase(world_cup_2026_bet.fulfilled, (state, action) => {
      const data = action.payload || {}
      if (data?.status === 1) {
        Object.assign(state.homepage, {
          ...pick(data, ['coin_num', 'target_list']),
          is_first_enter: false,
          acc_score: 0,
        })
      }
    })
    builder.addCase(getActivityInfo.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.activityInfo = data
    })
  },
})

export default WordCupCarnivalSlice.reducer

export const WordCupCarnivalActions = WordCupCarnivalSlice.actions

export const useReducerState = () => {
  const data = useSelector((state) => {
    return state.WordCupCarnival
  })
  return data
}
